import {Button} from './ui/button'
import {Card, CardContent, CardHeader, CardTitle} from './ui/card'

export function ErrorFallback() {
	const handleReload = () => {
		window.location.reload()
	}

	return (
		<div className='flex justify-center items-center h-screen bg-background'>
			<Card className='w-full max-w-md'>
				<CardHeader>
					<CardTitle className='text-destructive'>
						Something went wrong
					</CardTitle>
				</CardHeader>
				<CardContent className='space-y-4'>
					<p className='text-muted-foreground'>
						An unexpected error occurred. Our team has been notified.
					</p>
					<Button onClick={handleReload} variant='outline'>
						Reload page
					</Button>
				</CardContent>
			</Card>
		</div>
	)
}
